import { Layout, PtChain as PtChainComponent } from "components"
export const PtChain = () => {
 return (
  <Layout>
   <PtChainComponent />
  </Layout>
 )
}
